module.exports = __webpack_public_path__ + "static/media/21ECLAC1.aba1b671.jpg";